import { render, staticRenderFns } from "./ChildForm.vue?vue&type=template&id=25844540&"
import script from "./ChildForm.vue?vue&type=script&lang=js&"
export * from "./ChildForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports